export default "__VITE_ASSET__1661b468__$_?nuxt_component=async__"